module.exports = __webpack_public_path__ + "img/yewu.04c8f11a.png";